import { c as _c } from "react/compiler-runtime";
import { cn } from '@ncai-axe/react-ui-v3/utils';
import styles from './style.module.scss';
import { ListItem } from '../types';
type Props = {
  children?: React.ReactNode;
  className?: string;
} & ListItem;
const SelectListItem = t0 => {
  const $ = _c(14);
  const {
    children,
    className,
    label,
    labelStyle,
    leadingIcon,
    caption
  } = t0;
  if (children) {
    return children;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn(styles.selectListItem, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== leadingIcon) {
    t2 = leadingIcon && <div className={styles.leadingIcon}>{leadingIcon}</div>;
    $[2] = leadingIcon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== label || $[5] !== labelStyle) {
    t3 = <div className={styles.label} style={labelStyle}>{label}</div>;
    $[4] = label;
    $[5] = labelStyle;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== caption) {
    t4 = caption && <div className={styles.caption}>{caption}</div>;
    $[7] = caption;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
SelectListItem.displayName = 'SelectListItem';
export default SelectListItem;